var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "webContent flex",
      attrs: { scroll: "" },
      on: { scroll: _vm.listenScroll }
    },
    [
      _c("div", { staticClass: "mine" }, [
        _c("div", { staticClass: "area df hao jcb" }, [
          _c("div", { staticClass: "classify df hao" }, [
            _vm._v(_vm._s(_vm.classify))
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.list.length) + "个内容")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.list, function(v, i) {
            return _c("div", { staticClass: "li" }, [
              v.types == 1
                ? _c(
                    "div",
                    {
                      staticClass: "item",
                      on: {
                        click: function($event) {
                          return _vm.toDetail(v)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        v.question.announcement == 1
                          ? _c("i", { staticClass: "rule" })
                          : _vm._e(),
                        v.question.refining == 1
                          ? _c("i", { staticClass: "prize" })
                          : _vm._e(),
                        v.question.top == 1
                          ? _c("i", { staticClass: "top" })
                          : _vm._e(),
                        _vm._v(_vm._s(v.question.title))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "txt ov-4d",
                          domProps: { innerHTML: _vm._s(v.question.content) }
                        },
                        [_vm._v(_vm._s(v.question.content))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "end df hao" }, [
                        _c(
                          "div",
                          {
                            staticClass: "like",
                            class: { has: v.question.approval != 0 },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.likeItem(
                                  v.question.id,
                                  v.question.approval,
                                  1,
                                  v.question
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(v.question.approvalTotal))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "collect has",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.collectItem(v.id, i)
                              }
                            }
                          },
                          [_vm._v(_vm._s(v.question.collectionTotal))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "user" }, [
                          _vm._v(_vm._s(v.question.creatorName || ""))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "date" }, [
                          _vm._v(_vm._s(_vm.dateTime(v.question.createTime)))
                        ])
                      ])
                    ]
                  )
                : v.types == 2
                ? _c(
                    "div",
                    {
                      staticClass: "item",
                      on: {
                        click: function($event) {
                          return _vm.toDetail(v)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        v.answer.announcement == 1
                          ? _c("i", { staticClass: "rule" })
                          : _vm._e(),
                        v.answer.refining == 1
                          ? _c("i", { staticClass: "prize" })
                          : _vm._e(),
                        v.answer.top == 1
                          ? _c("i", { staticClass: "top" })
                          : _vm._e(),
                        _vm._v(_vm._s(v.answer.title))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "txt ov-4d",
                          domProps: { innerHTML: _vm._s(v.answer.content) }
                        },
                        [_vm._v(_vm._s(v.answer.content))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "end df hao" }, [
                        _c(
                          "div",
                          {
                            staticClass: "like",
                            class: { has: v.answer.approval != 0 },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.likeItem(
                                  v.answer.id,
                                  v.answer.approval,
                                  2,
                                  v.answer
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(v.answer.approvalTotal))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "collect has",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.collectItem(v.id, i)
                              }
                            }
                          },
                          [_vm._v(_vm._s(v.answer.collectionTotal))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "user" }, [
                          _vm._v(_vm._s(v.answer.creatorName || ""))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "date" }, [
                          _vm._v(_vm._s(_vm.dateTime(v.answer.createTime)))
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c24f1fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c24f1fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/me/collectList/collectList.vue
// module id = null
// module chunks = 